import React from 'react'
import { motion } from 'framer-motion'

const LoadingSkeleton = ({ type = 'card', count = 1, className = '' }) => {
  const skeletonVariants = {
    loading: {
      opacity: [0.3, 0.7, 0.3],
      transition: {
        repeat: Infinity,
        duration: 1.5,
        ease: "easeInOut"
      }
    }
  }

  const renderCardSkeleton = () => (
    <div className="bg-white rounded-lg shadow-md overflow-hidden">
      <motion.div
        variants={skeletonVariants}
        animate="loading"
        className="h-48 bg-gray-200"
      />
      <div className="p-4 space-y-3">
        <motion.div
          variants={skeletonVariants}
          animate="loading"
          className="h-6 bg-gray-200 rounded"
        />
        <motion.div
          variants={skeletonVariants}
          animate="loading"
          className="h-4 bg-gray-200 rounded w-3/4"
        />
        <motion.div
          variants={skeletonVariants}
          animate="loading"
          className="h-4 bg-gray-200 rounded w-1/2"
        />
      </div>
    </div>
  )

  const renderListSkeleton = () => (
    <div className="bg-white rounded-lg shadow-md p-4 space-y-3">
      <div className="flex items-center space-x-4">
        <motion.div
          variants={skeletonVariants}
          animate="loading"
          className="w-16 h-16 bg-gray-200 rounded-lg"
        />
        <div className="flex-1 space-y-2">
          <motion.div
            variants={skeletonVariants}
            animate="loading"
            className="h-5 bg-gray-200 rounded w-3/4"
          />
          <motion.div
            variants={skeletonVariants}
            animate="loading"
            className="h-4 bg-gray-200 rounded w-1/2"
          />
        </div>
      </div>
    </div>
  )

  const renderSearchSkeleton = () => (
    <div className="space-y-4">
      <motion.div
        variants={skeletonVariants}
        animate="loading"
        className="h-12 bg-gray-200 rounded-lg"
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {[1, 2, 3].map(i => (
          <motion.div
            key={i}
            variants={skeletonVariants}
            animate="loading"
            className="h-10 bg-gray-200 rounded-lg"
          />
        ))}
      </div>
    </div>
  )

  const renderMapSkeleton = () => (
    <motion.div
      variants={skeletonVariants}
      animate="loading"
      className="w-full h-96 bg-gray-200 rounded-lg"
    />
  )

  const renderStorySkeleton = () => (
    <div className="space-y-6">
      <motion.div
        variants={skeletonVariants}
        animate="loading"
        className="h-64 bg-gray-200 rounded-lg"
      />
      <div className="space-y-4">
        <motion.div
          variants={skeletonVariants}
          animate="loading"
          className="h-8 bg-gray-200 rounded"
        />
        <motion.div
          variants={skeletonVariants}
          animate="loading"
          className="h-4 bg-gray-200 rounded w-full"
        />
        <motion.div
          variants={skeletonVariants}
          animate="loading"
          className="h-4 bg-gray-200 rounded w-5/6"
        />
        <motion.div
          variants={skeletonVariants}
          animate="loading"
          className="h-4 bg-gray-200 rounded w-4/6"
        />
      </div>
    </div>
  )

  const renderSkeleton = () => {
    switch (type) {
      case 'list':
        return renderListSkeleton()
      case 'search':
        return renderSearchSkeleton()
      case 'map':
        return renderMapSkeleton()
      case 'story':
        return renderStorySkeleton()
      case 'card':
      default:
        return renderCardSkeleton()
    }
  }

  return (
    <div className={className}>
      {Array.from({ length: count }, (_, index) => (
        <div key={index} className={type === 'card' ? 'mb-4' : ''}>
          {renderSkeleton()}
        </div>
      ))}
    </div>
  )
}

export default LoadingSkeleton
